import _ from "lodash";
import { EventBus } from "./event-bus.js";
import loc from "./location";
import camera from "./camera";
import wifi from "./wifi";
import fb from "@/utilities/firebase";
import uuid from "./uniqueid";

function playServiceEnabled() {
  return new Promise(function(resolve, reject) {
    var success = function(response) {
      // response.isGooglePlayServicesAvailable is a boolean value
      resolve(response.isGooglePlayServicesAvailable);
    };

    var failure = function(response) {
      resolve(false);
    };

    try {
      GooglePlayServicesCheck.check(success, failure);
    } catch (e) {
      resolve(false);
    }
  });
}

async function punch(ctx, punchObj) {
  return new Promise(
    async function(resolve, reject) {
      const { punchObj, ctx } = this;

      console.log(punchObj);
      const self = this;

      var playService = true;

      if (device.platform.toLowerCase() == "android" && parseInt(device.version, 10) <= 6) {
        playService = await playServiceEnabled();
        console.log("Play service is " + playService);
      }

      EventBus.$on(
        "punch",
        function(reason) {
          if (reason == "cancel") {
            try {
              const video = window.document.getElementById("camera");

              video.srcObject.getTracks().forEach(track => {
                track.stop();
              });

              setTimeout(() => {
                video.remove();
                EventBus.$emit("closeCamera");
              }, 1000);
            } catch (e) {
              console.log(e);
            }

            console.log("Stopping checking");

            return this.reject(new Error(reason));
          }
        }.bind({
          reject: reject,
          resolve: resolve
        })
      );

      EventBus.$emit("punch", "start");
      // Get the punch mode
      const { mode } = punchObj;
      let postURL = "";

      try {
        punchObj.deviceFingerprint = await uuid.get();
      } catch (e) {
        console.log(e);
      }
      try {
        punchObj.deviceMeta = {
          uuid: device.uuid,
          model: device.model,
          isVirtual: device.isVirtual,
          version: device.version,
          serial: device.serial,
          manufacturer: device.manufacturer,
          platform: device.platform
        };

        punchObj.deviceMeta = JSON.stringify(punchObj.deviceMeta);
      } catch (e) {
        console.log(e);
      }

      if (mode == "ft") {
        var settings = punchObj.fieldTrackingSettings;

        try {
          EventBus.$emit("punch", "Trying to get location");
          punchObj.gps = await loc.get();
          EventBus.$emit("punch", "Got location");
        } catch (e) {
          console.log(e);
          EventBus.$emit("punch", "Failed To Get Location");
        }

        if (settings.isPhotoid) {
          try {
            EventBus.$emit("punch", "Trying to capture image. Smile!");
            punchObj.image = await camera.getPicture(ctx, {
              destinationType: navigator.camera.DestinationType.FILE_URI,
              quality: 30,
              correctOrientation: true,
              targetWidth: 1024,
              cameraDirection: navigator.camera.Direction.FRONT
            });
            EventBus.$emit("punch", "Got Image!");
          } catch (e) {
            console.log(e);
            EventBus.$emit("punch", "Failed To Get Image");
          }
        }

        postURL = "fieldTrackings/punch";
      } else {
        // Lets validate these settings
        var settings = punchObj.securitySettings || {};

        if (settings.isWifissid && device.platform != "browser") {
          try {
            EventBus.$emit("punch", "Trying to get Wifi");
            punchObj.wifi = await wifi.get();
            console.log("Got wifi " + JSON.stringify(punchObj.wifi));
            EventBus.$emit("punch", "Got Wifi");
          } catch (e) {
            console.log(e);
            EventBus.$emit("punch", "Failed To Get Wifi");
          }
        }

        //if (settings.isGeoseal) {
        //Always getting geoseal

        try {
          if ((settings.isGeoseal || settings.detectHotspot) && !punchObj.gps) {
            punchObj.gps = await loc.get();

            EventBus.$emit("punch", "Trying to get location");
          }

          if (settings.isGeoseal) {
            EventBus.$emit("punch", "Got Location");
          }
        } catch (e) {
          console.log(e);
          if (settings.isGeoseal) {
            EventBus.$emit("punch", "Failed To Get Location");
          }
        }
        //}

        // console.log("Geoseal enabled",punchObj.gps)

        if (settings.isPhotoid) {
          try {
            EventBus.$emit("punch", "Trying to capture image. Smile!");
            punchObj.image = await camera.getPicture(ctx, {
              destinationType: navigator.camera.DestinationType.FILE_URI,
              quality: 30,
              correctOrientation: true,
              targetWidth: 1024,
              cameraDirection: navigator.camera.Direction.FRONT
            });
            EventBus.$emit("punch", "Got Image!");
          } catch (e) {
            console.log("Camera", e);
            EventBus.$emit("punch", "Failed To Get Image");
          }
        }
        postURL = "attendances/punch";
      }

      EventBus.$emit("punch", "Sending information to server");

      // Sending to server via Multipart-form

      const imageURI = punchObj.image;

      if (!imageURI || punch.manualPunch || device.platform == "browser" || !playService) {
        const data = new FormData();
        for (const x in punchObj) {
          if (typeof punchObj[x] === "object") data.append(x, JSON.stringify(punchObj[x]));
          else data.append(x, punchObj[x]);
        }

        console.log("Sending to server");
        ctx.$http
          .post(ctx.$store.state.endpoint + postURL, data, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: ctx.$store.state.user.id
            }
          })
          .then(
            response => {
              EventBus.$emit("punch", "sentToServer");
              EventBus.$emit("punch", "stop");
              resolve(response.body);

              fb.log("punch", { mode: punchObj.mode });
            },
            error => {
              console.log(error);
              reject(error);
            }
          );
      } else {
        console.log("Detected image upload case");
        const options = new FileUploadOptions();
        options.fileKey = "file";
        options.fileName = imageURI.substr(imageURI.lastIndexOf("/") + 1);
        options.mimeType = "image/jpeg";

        const params = punchObj;
        options.params = params;
        options.chunkedMode = true;
        options.headers = {
          Authorization: ctx.$store.state.user.id,
          Connection: "close"
        };

        const ft = new FileTransfer();
        ft.upload(
          imageURI,
          ctx.$store.state.endpoint + postURL,
          function(result) {
            EventBus.$emit("punch", "Send to server");
            EventBus.$emit("punch", "stop");

            try {
              fb.log("punch", { mode: punchObj.mode });
            } catch (e) {
              console.log(e);
            }

            this.resolve(JSON.parse(result.response));
          }.bind({
            resolve
          }),
          function(error) {
            alert("Error uploading image");
            console.log(error);
            this.reject(error);
          }.bind({
            reject
          }),
          options
        );
      }

      /*
         ctx.$http.post(ctx.$store.state.endpoint + postURL, punchObj, {
            headers: {
                'Authorization': ctx.$store.state.user.id
            }
        }).then(response => {
            console.log(response.body)
            EventBus.$emit("punch","sentToServer")
            EventBus.$emit("punch","stop")
            resolve(response)
        }, error => {
            console.log(error)
            reject(error)
        });

        */
    }.bind({
      punchObj,
      ctx
    })
  );
}

export default punch;
